// extracted by mini-css-extract-plugin
export default {"fileDisplay":"FileAttachment_fileDisplay__pSE4r","icon":"FileAttachment_icon__QCvfU"};